enum Partner {
  LIENERT = 'lienert',
  MATCHFLIX = 'matchflix',
  PERSONALTOTAL = 'personaltotal',
  SENATOR = 'senator',
}

export default Partner;
